<template>
    <div class="container">

        <div class="card">
            <div class="card-header">
                Nauja subranga
            </div>
            <div class="card-body">
                <div class="form-row">
                    <div class="col-12 col-md-6">
                        <label for="eq_id">Įranga</label>
                        <!--<select class="form-control" id="eq_id" v-model="new_equipment">-->
                        <!--<option v-for="e in equipment" :value="{id:e.id, text:e.name, price:e.price, power:e.power, equipment_type_id: e.equipment_type_id}">{{ e.type.name }} {{ e.name }} ({{ e.warranty }})</option>-->
                        <!--</select>-->
                        <v-select v-if="equipment" class="vue-select2s" id="eq_id" name="select2"
                                  :options="equipment" label="long_name"
                                  :model.sync="new_equipment"
                                  v-model="new_equipment"
                                  :searchable="true" language="en-US">
                        </v-select>

                    </div>
                    <div class="col-6 col-md-3">
                        <label for="eq_qty">Kiekis</label>
                        <input id="eq_qty" class="form-control" @keyup="enter_submit" v-model="new_equipment_qty"
                               type="text">
                    </div>
                    <div class="col-6 col-md-3">
                        <label for="">&nbsp;</label>
                        <button @click="add_equipment_to_offer" class="form-control btn btn-outline-success">Pridėti
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="form-row" v-for="(se, i) in selected_equipment">
                    <div @click="deleteSelected(i, se.price, se.quantity)" class="col-1">-</div>
                    <div class="col-11 col-md-6">{{ se.equipment_text }} -- {{ se.quantity }} vnt.</div>
                </div>

                <div class="form-row">
                    <div class="col-12 col-lg-2">
                        <div class="form-group">
                            <label for="price">Kodas-1</label>
                            <div class="input-group">
                                <input id="code_1" class="form-control" type="text" v-model="code_1">
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-8">
                        <div class="form-group">
                            <label for="price">Pavadinimas-1</label>
                            <div class="input-group">
                                <input id="text_1" class="form-control" type="text" v-model="text_1">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2">
                        <div class="form-group">
                            <label for="price">Kaina-1 <span class="small">be PVM</span></label>
                            <div class="input-group">
                                <input id="price_1" class="form-control" type="text" v-model="price_1">
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-6 col-lg-3">
                        <div class="form-group">
                            <label for="price">Suma</label>
                            <div class="input-group">
                                <input id="price" class="form-control" type="text" readonly v-model="total">
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="col-6 col-lg-3">
                        <div class="form-group">
                            <label for="">Galia</label>
                            <div class="input-group">
                                <input id="power" class="form-control" type="text" v-model="power">
                                <div class="input-group-append">
                                    <div class="input-group-text">kW</div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                Sub klientas
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="">Vardas
                                            </label>
                                            <div class="input-group">
                                                <input id="percent1" class="form-control" type="text"
                                                       v-model="sub_name">
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="">Telefonas</label>
                                            <div class="input-group">
                                                <input id="percent2" class="form-control" type="text"
                                                       v-model="sub_phone">
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="">Adresas</label>
                                            <div class="input-group">
                                                <input id="percent3" class="form-control" type="text"
                                                       v-model="sub_address">
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <div class="card-footer">
                <button @click="store_sub" class="btn btn-outline-success">Sukurti</button>
            </div>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select';

    export default {
        name: "NewSub",
        props: ['cid', 'uid'],
        components: {
            vSelect,
        },
        data() {
            return {
                customer_id: '',
                power: '',
                equipment: '',
                usage: '',
                new_equipment: '',
                new_equipment_qty: '',
                selected_equipment: [],
                price: '',
                discount: '0',
                total: '',
                user_id: '',
                sub_name: '',
                sub_phone: '',
                sub_address: '',
                code_1: '',
                text_1: 'Darbai pagal užsakymą',
                price_1: ''
            }
        },
        watch: {
            price: function (val) {
                if (val > 999) {
                    if (this.payment1) {
                        this.payment1 = Math.round((((val - this.discount) / 100) * this.percent1()) / 100) * 100;
                    }
                    if (this.payment3) {
                        this.payment3 = Math.round(((val / 100) * this.percent3()) / 100) * 100;
                    }
                    if (this.percent1 && this.percent3) {
                        this.payment2 = this.price - (this.payment1 + this.payment3);
                    }
                }

            },

            price_1: function () {
                this.price = this.total = Number(this.price_1.replace(/,/g, '.'));

            }
        },
        mounted() {

            axios.get('/get_equipment').then(res => {
                this.equipment = res.data
            });


        },
        created() {

        },
        methods: {
            add_equipment_to_offer() {
                this.selected_equipment.push({
                    equipment_id: this.new_equipment.id,
                    equipment_text: this.new_equipment.name,
                    quantity: this.new_equipment_qty,
                    price: this.new_equipment.price
                });
                this.price = Number(this.price) + (Number(this.new_equipment.price) * Number(this.new_equipment_qty));
                this.percent1 = this.percent3 = '';
                console.log(this.new_equipment.power);
                if (this.new_equipment.power > 0 && this.new_equipment.equipment_type_id == 1) {
                    this.power = Number(this.power) + Number(this.new_equipment.power) * Number(this.new_equipment_qty);
                    this.power = this.power.toFixed(2);
                }
                this.new_equipment_qty = '';
            },
            deleteSelected(i, price, quantity) {
                this.selected_equipment.splice(i, 1);
                this.price = Number(this.price) - (Number(price) * Number(quantity));
            },
            store_sub(e) {
                console.log(this._data);
                let got_err = 0;
                // this.price = this.price.replace(/,/g, '.');
                // this.price_1 = this.price_1.replace(/,/g, '.');
                // this.power = this.power.replace(/,/g, '.');
                if (this.code_1 != '' && this.price_1 != '') {
                    if (this.code_1 == '') {
                        $('#code_1').addClass('is-invalid');
                        got_err = 1;

                    }

                    if (this.price_1 == 0) {
                        $('#price_1').addClass('is-invalid');
                        got_err = 1;

                    }
                    if (this.power < 1) {
                        $('#power').addClass('is-invalid');
                        got_err = 1;

                    }

                    if (got_err == 1) {
                        return;
                    }
                }else{
                    this.code_1 = '';
                    this.text_1 = '';
                    this.price_1 = '';
                    this.power = 0;
                }

                $(e.target).attr('disabled', true);

                this.customer_id = this.$props.cid;
                this.user_id = this.$props.uid;
                //check tootal is null
                if(this.total < 0.01){
                    this.total = 0;
                }
                axios.post('/store_sub', this._data).then(res => {
                    console.log(res.data);
                    if(res.data.offer.total == 0){
                        window.location.replace('/editsub/' + res.data.offer.id);
                    }else{
                        window.location.replace('/customer/' + this.$props.cid)
                    }

                })
            },

            enter_submit(e) {
                if (e.keyCode == 13) {
                    console.log('enter');
                    this.add_equipment_to_offer();
                }

            }
        }
    }
</script>

<style scoped>

</style>